module.exports = __webpack_public_path__ + "static/media/iconDashboard.35dac6e8.svg";